import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { injectEnvToWindow } from './config/clientEnv'

// Definir variables de entorno globales para que estén disponibles en window
// Este bloque se ejecutará solo en el cliente
if (typeof window !== 'undefined') {
  // Estas variables serán reemplazadas por Vite durante la compilación
  (window as any).__VITE_ENV_MODE__ = process.env.NODE_ENV;
  (window as any).__VITE_ENV_API_URL__ = process.env.VITE_API_URL;
  (window as any).__VITE_ENV_GOOGLE_MAPS_API_KEY__ = process.env.VITE_GOOGLE_MAPS_API_KEY;
}

// Inyectar variables de entorno en el objeto window
injectEnvToWindow();

// Imprimir información de entorno para depuración
console.log('Entorno:', typeof window !== 'undefined' ? window.__VITE_MODE__ : 'unknown');
console.log('API URL:', typeof window !== 'undefined' ? window.__VITE_API_URL__ : 'unknown');
console.log('Host actual:', typeof window !== 'undefined' ? window.location.hostname : 'unknown');

// Verificar si estamos en producción y mostrar advertencia si la URL de API es localhost
if (typeof window !== 'undefined' && window.__VITE_MODE__ === 'production' && window.__VITE_API_URL__?.includes('localhost')) {
  console.error('⚠️ ADVERTENCIA: La aplicación está en modo producción pero la URL de API apunta a localhost');
  console.error('Corrigiendo automáticamente a https://www.propiedadeslatam.com');
  window.__VITE_API_URL__ = 'https://www.propiedadeslatam.com';
}

// Verificar si estamos en localhost y mostrar advertencia si la URL de API es producción
if (typeof window !== 'undefined' && window.location.hostname === 'localhost' && !window.__VITE_API_URL__?.includes('localhost')) {
  console.error('⚠️ ADVERTENCIA: La aplicación está en localhost pero la URL de API apunta a producción');
  console.error('Corrigiendo automáticamente a http://localhost:3000');
  window.__VITE_API_URL__ = 'http://localhost:3000';
}

createRoot(document.getElementById("root")!).render(<App />);
